// pages/Home.js
import { useState } from "react";
import BottomTabs from "../components/BottomTabs";
import UserInfoOverlay from "../components/UserInfoOverlay";
import { TABS } from "../constants/tabs";

export default function Home({
  currentUser,
  myChatId,
  groups = [],
  feedSocket,
  myUserName,
  myDisplayName,
  onLogout,
  activeTab,
  setActiveTab,
   interactionsBadgeCount = 0,
   notificationsBadgeCount = 0,
   uploadImage,
   socket,
    handleOpenGroupFromUserInfo,
}) {
  // Own-profile overlay — Profile tab opens this instead of navigating
  // straight into My Posts. Posts/edit/delete are rendered inside via the
  // shared AuthorPostsContext (see GroupChat.js renderAuthorPosts), which
  // already shows the 3-dot menu and Earnings (not Support) for your own
  // posts because it compares post.author.chatId to myChatId.
  const [showProfile, setShowProfile] = useState(false);
  const avatarUrl =
    currentUser?.profileImageUrl ||
    currentUser?.avatarUrl ||
    null;

  // Your own follower/following counts live on currentUser.chatInfo, kept in
  // sync by GroupChat.js's onFollowCounts socket handler — but that handler
  // only fires once feedSocket.getFollowCounts() has been called for your
  // own chatId, so we trigger it when the overlay opens.
  const myChatInfo = currentUser?.chatInfo?.find(
    (ci) => String(ci.chatId) === String(myChatId)
  ) || currentUser?.chatInfo?.[0];

  const openProfile = () => {
    setShowProfile(true);
    feedSocket?.getFollowCounts?.({ targetChatId: myChatId });
  };

  return (
  <aside className="flex h-full w-full flex-col bg-white dark:bg-neutral-900">
      
     {/* HEADER */}
<div className="px-4 py-4 border-b dark:border-neutral-800 flex items-center gap-3">
  <div className="w-10 h-10 shrink-0">
    {avatarUrl ? (
      <img
        src={avatarUrl}
        alt={myDisplayName || myUserName || "Me"}
        className="w-10 h-10 rounded-full object-cover"
      />
    ) : (
      <div className="w-10 h-10 rounded-full bg-neutral-300 dark:bg-neutral-700 flex items-center justify-center text-lg">
        👤
      </div>
    )}
  </div>
  <div className="min-w-0">
    <div className="text-sm font-medium truncate">
      {myDisplayName || myUserName || "User"}
    </div>
    <div className="text-xs text-neutral-500 truncate">
      @{myUserName || "user"}
    </div>
  </div>
</div>

      {/* CONTENT */}
      <div className="flex-1 px-4 py-4 space-y-3">
        <button
          onClick={() => setActiveTab(TABS.SETTINGS)}
          className="w-full text-left px-4 py-2 rounded hover:bg-neutral-100 dark:hover:bg-neutral-800"
        >
          ⚙️ Settings
        </button>

        <button
          onClick={onLogout}
          className="w-full text-left px-4 py-2 rounded text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20"
        >
          🚪 Log out
        </button>
      </div>

      {/* BOTTOM NAV (DESKTOP HOME) */}
   <BottomTabs
  variant="home"
  activeTab={activeTab}
  onChangeTab={setActiveTab}
  onOpenConnect={() => setActiveTab(TABS.CONNECT)}
  onOpenProfile={openProfile}
  interactionCount={interactionsBadgeCount}   // 🔥 ADD THIS
   notificationCount={notificationsBadgeCount}
/>

      {/* OWN PROFILE OVERLAY */}
     <UserInfoOverlay
  open={showProfile}
  onClose={() => setShowProfile(false)}
  user={{ ...currentUser, chatId: myChatId }}
  myChatId={myChatId}
  mutualGroups={groups}
  onOpenGroup={handleOpenGroupFromUserInfo}
  followersCount={myChatInfo?.followersCount ?? 0}
  followingCount={myChatInfo?.followingCount ?? 0}
  uploadImage={uploadImage}
  socket={socket}
/>
    </aside>
  );
}